// extracted by mini-css-extract-plugin
export default {"snake":"PayoutPauseButton_snake__aT4+7","payout-pause-snake":"PayoutPauseButton_payout-pause-snake__Au-Fx"};